/**
 * Route for `post-affiliate-pro-integration-via-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PostAffiliateProIntegrationViaApiPage } from "../features/post-affiliate-pro-integration-via-api/PostAffiliateProIntegrationViaApiPage";

export const postAffiliateProIntegrationViaApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/post-affiliate-pro-integration-via-api",
	component: PostAffiliateProIntegrationViaApiPage,
});

export default postAffiliateProIntegrationViaApiRoute;
